<app-layout-main [size]="size" padding="md">
  <div class="layout-content">
    <ng-content />
  </div>
</app-layout-main>
